export default "__VITE_ASSET__DGKIVxqF__"